export enum FlooriFontFamily {
    inter = 'inter',
    roboto = 'roboto',
    sans = 'sans-serif',
    avenir = 'avenir-next',
    assistant = 'assistant',
    madefor = 'madefor-display',
}

export interface FlooriFont {
    family: FlooriFontFamily;
    url: string;
}
